import { register } from "async-ops";
import { getDefaultOptions, throwExceptionErrors } from "../../../utils/fetch";
import { callMdaePublicApi } from "../../../call-web-api";
import mdaeNotfy, { NOTIFY_MESSAGE_TYPE } from "../../common_widgets/toast/notify";

export const DELETE_DOCUMENT_LIBRARY = "DELETE_DOCUMENT_LIBRARY";

export const service = async (data) => {
  const response: any = await callMdaePublicApi({
    type: "POST",
    contentType: "application/json",
    url: "/Api/Document/DeleteDocument",
    isRoutedApiCall: true,
    ...getDefaultOptions(),
    body: Array.isArray(data)
      ? JSON.stringify({ DocumentsToDelete: data, attachedLevelName: "DL" })
      : JSON.stringify({ documentId: data.documentId, attachedLevelName: "DL" }),
  });
  throwExceptionErrors(response);
  if (response && response.isDeleted) {
    if (Array.isArray(data) && data.length > 1) {
      mdaeNotfy({ message: data.length + " Documents Deleted Successfully!", messageType: NOTIFY_MESSAGE_TYPE.SUCCESS });
    } else {
      const name = Array.isArray(data) ? data[0].documentName : data.documentName;
      mdaeNotfy({ message: name + " Deleted Successfully!", messageType: NOTIFY_MESSAGE_TYPE.SUCCESS });
    }
  }
  return response;
};

const mockData = () => [];
const mock = () => Promise.resolve(mockData());

register(DELETE_DOCUMENT_LIBRARY, service, mock);
